import React, { Component, Fragment } from "react";
import classNames from "classnames";
import Dropzone from "react-dropzone";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import EmpList from "./EmpListMulti";
import { post } from "axios";
import GlobalValue from "GlobalValue";
import { _callApiMessage2, _callApiMessage3 } from "GlobalFunction";
const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  }
});
class NoticeEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      memo: "",
      files: [],
      filesImg: [],
      showEmpList: false,
      crudGubun: "C"
    };
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };
  onDrop = files => {
    // // POST to a test endpoint for demo purposes
    // const req = request.post("https://httpbin.org/post");
    // files.forEach(file => {
    //   req.attach(file.name, file);
    // });
    // req.end();
  };
  onPreviewImgDrop = async files => {
    await this.setState({
      filesImg: this.state.filesImg.concat(files)
    });
    console.log(this.state);
  };

  onPreviewDrop = files => {
    console.log(files);
    this.setState({
      files: this.state.files.concat(files)
    });
  };
  handleEdocEmpListClose = () => {
    this.setState({ showEmpList: false });
  };
  addNotice = () => {
    const url =
      this.state.crudGubun === "C"
        ? `${GlobalValue.BASE_URL2}notice/insertNotice`
        : this.state.crudGubun === "U"
        ? `${GlobalValue.BASE_URL2}notice/updateNotice`
        : null;
    const formData = new FormData();

    // if (this.props.gubun === "U") {
    //   for (let i = 0; i < this.state.filesImgTemp.length; i++) {
    //     formData.append("imagelist", this.state.filesImgTemp[i]);
    //   }
    //   for (let i = 0; i < this.state.filesTemp.length; i++) {
    //     formData.append("filelist", this.state.filesTemp[i]);
    //   }
    // } else {
    for (let i = 0; i < this.state.filesImg.length; i++) {
      formData.append("imagelist", this.state.filesImg[i]);
    }
    for (let i = 0; i < this.state.files.length; i++) {
      formData.append("filelist", this.state.files[i]);
    }
    // }
    if (this.props.gubun === "U") {
      formData.append("ejoinupdate", JSON.stringify(this.state.ERefUpdate));
      formData.append("noticeInit", JSON.stringify(this.state.noticeInit));
    } else {
      formData.append("ejoinline", JSON.stringify(this.state.ERef));
    }
    formData.append("title", this.state.title);
    formData.append("memo", this.state.memo);
    formData.append(
      "edstcode",
      JSON.parse(localStorage.getItem("USERINFO")).SUSTCode
    );
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    console.log(formData);
    return post(url, formData, config);
  };
  addRef = emp => {
    this.setState({ showEmpList: false, ERef: emp, ERSTCodeList: emp });
  };
  addRefUpdate = emp => {
    this.setState({ showEmpList: false, ERefUpdate: emp, ERSTCodeList: emp });
  };
  handleSubmit = e => {
    e.preventDefault();
    if (this.state.ERef === undefined) {
      alert("받는사람을 선택해주세요.");
      return;
    }
    if (this.state.title === "") {
      alert("제목을 입력해주세요.");
      return;
    }
    if (this.state.memo === "") {
      alert("내용을 입력해주세요.");
      return;
    }
    this.addNotice().then(response => {
      console.log(response);
      if (response.data === "OK") {
        alert("등록 되었습니다.");
        this.props._isEdit();
      } else {
        alert(response.data);
      }
    });
  };
  popFileImg = async index => {
    let sliceFile = this.state.filesImg;
    sliceFile.splice(index, 1);
    await this.setState({ filesImg: sliceFile });
  };

  popFile = async index => {
    let sliceFile = this.state.files;
    sliceFile.splice(index, 1);
    await this.setState({ files: sliceFile });
  };
  deleteServerFile = (file, index) => {
    let sliceFile = this.state.filesImgTemp;
    sliceFile.splice(index, 1);
    _callApiMessage3("notice/deleteFile", file)
      .then(responsBody => {
        console.log("?", responsBody);
        if (responsBody === "remove") {
          this.setState({ filesImgTemp: sliceFile });
        } else {
          // alert("서버에 등록된 파일에 문제가 있습니다.");
        }
      })
      .catch(error => {
        console.log("eror", error);
      });
  };
  deleteServerFile2 = (file, index) => {
    let sliceFile = this.state.filesTemp;
    sliceFile.splice(index, 1);
    _callApiMessage3("notice/deleteFile", file)
      .then(responsBody => {
        console.log("?", responsBody);
        if (responsBody === "remove") {
          this.setState({ filesTemp: sliceFile });
        } else {
          // alert("서버에 등록된 파일에 문제가 있습니다.");
        }
      })
      .catch(error => {
        console.log("eror", error);
      });
  };
  componentDidMount = async () => {
    if (this.props.gubun === "U") {
      let noticeItem = this.props.noticeItem;
      console.log(
        "this.props2",
        noticeItem,
        noticeItem.files.filter(item => item.EFGubun === 1)
      );
      await this.setState({
        title: noticeItem.EDTITLE,
        memo: noticeItem.EDTEXT,
        filesImgTemp: noticeItem.files.filter(item => item.EFGubun === 0),
        filesTemp: noticeItem.files.filter(item => item.EFGubun === 1),
        ERef: noticeItem.refs,
        crudGubun: "U",
        noticeInit: {
          EDDateTime: noticeItem.EDDATETIME,
          EDMilliSecond: noticeItem.EDMILLISECOND,
          EDSTCode: noticeItem.EDSTCODE
        }
      });
    }
    console.log("this.state", this.state);
  };
  render() {
    const { classes } = this.props;
    const previewStyle = {
      display: "inline",
      width: 100,
      height: 100
    };
    // console.log(this.props);
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          margin: "50px",
          backgroundColor: "#fff",
          padding: "15px"
        }}
      >
        {this.state.showEmpList ? (
          <EmpList
            openDialog={this.state.openEmpList}
            handleEdocEmpListClose={this.handleEdocEmpListClose}
            addRef={this.props.gubun === "U" ? this.addRefUpdate : this.addRef}
            refList={this.props.refList}
            sysCompany={this.props.sysCompany}
          />
        ) : (
          <div
            style={{ display: "flex", width: "100%", flexDirection: "column" }}
          >
            <form onSubmit={e => this.handleSubmit(e)}>
              <div style={{ height: "90px" }}>
                <TextField
                  id="outlined-name"
                  label="제목"
                  value={this.state.title}
                  onChange={this.handleChange("title")}
                  margin="normal"
                  variant="outlined"
                  style={{ width: "100%" }}
                />
              </div>
              <div style={{ height: "270px" }}>
                <TextField
                  id="outlined-multiline-static"
                  label="내용"
                  multiline
                  rows="10"
                  style={{ width: "100%" }}
                  margin="normal"
                  variant="outlined"
                  value={this.state.memo}
                  onChange={this.handleChange("memo")}
                />
              </div>
              <div style={{ height: "150px" }}>
                <label>이미지</label>
                <Dropzone
                  onDrop={acceptedFiles => this.onPreviewImgDrop(acceptedFiles)}
                  accept="image/*"
                >
                  {({ getRootProps, getInputProps }) => (
                    <section>
                      <div
                        {...getRootProps()}
                        style={{
                          height: "50px",
                          border: "1px solid",
                          borderStyle: "dotted"
                        }}
                      >
                        <input {...getInputProps()} />
                        <p>
                          화면에 보여질 이미지를 드래그 또는 클릭하여
                          삽입해주세요.
                        </p>
                      </div>
                    </section>
                  )}
                </Dropzone>
                {(this.state.filesImg.length > 0 ||
                  this.state.filesImgTemp !== undefined) && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      overflow: "auto",
                      height: "50px"
                    }}
                  >
                    <ul>
                      {this.state.filesImgTemp &&
                        this.state.filesImgTemp.map((file, index) => (
                          <li key={index}>
                            <label key={index}>
                              {file.EFPath.split("/")[3]}
                            </label>
                            <label
                              type="none"
                              onClick={() => this.deleteServerFile(file)}
                              style={{ backgroundColor: "#d1d1d1" }}
                            >
                              기존파일 삭제
                            </label>
                          </li>
                        ))}
                      {this.state.filesImg.map((file, index) => (
                        <li key={index + 100}>
                          <label key={index + 100}>{file.name}</label>
                          <label
                            type="none"
                            onClick={() => this.popFileImg(index)}
                            style={{ backgroundColor: "#d1d1d1" }}
                          >
                            삭제
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <div style={{ height: "150px" }}>
                <label>첨부파일</label>
                <Dropzone
                  onDrop={acceptedFiles => this.onPreviewDrop(acceptedFiles)}
                >
                  {({ getRootProps, getInputProps }) => (
                    <section>
                      <div
                        {...getRootProps()}
                        style={{
                          height: "50px",
                          border: "1px solid",
                          borderStyle: "dotted"
                        }}
                      >
                        <input {...getInputProps()} />
                        <p>첨부파일을 드래그 또는 클릭하여 삽입해주세요.</p>
                      </div>
                    </section>
                  )}
                </Dropzone>
                {(this.state.files.length > 0 ||
                  this.state.filesTemp !== undefined) && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      overflow: "auto",
                      height: "50px"
                    }}
                  >
                    <ul>
                      {this.state.filesTemp &&
                        this.state.filesTemp.map((file, index) => (
                          <li key={index}>
                            <label key={index}>
                              {file.EFPath.split("/")[3]}
                            </label>
                            <label
                              type="none"
                              onClick={() => this.deleteServerFile2(file)}
                              style={{ backgroundColor: "#d1d1d1" }}
                            >
                              기존파일 삭제
                            </label>
                          </li>
                        ))}
                      {this.state.files.map((file, index) => (
                        <li key={index}>
                          <label key={index}>{file.name}</label>
                          <label
                            type="none"
                            onClick={() => this.popFile(index)}
                            style={{ backgroundColor: "#d1d1d1" }}
                          >
                            삭제
                          </label>
                        </li>
                      ))}
                      {/* {this.state.files.map((file, index) => (
                        <li key={index}>
                          <label key={index}>{file.name}</label>
                        </li>
                      ))} */}
                    </ul>
                  </div>
                )}
              </div>
              <button
                style={{
                  height: "50px",
                  border: "1px solid",
                  borderStyle: "dotted",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center"
                }}
                onClick={() => {
                  this.setState({ showEmpList: true });
                }}
              >
                {this.props.gubun === "U"
                  ? !this.state.ERefUpdate
                    ? "받는 사람추가"
                    : `${this.state.ERefUpdate[0].SUNAME} 외 ${this.state
                        .ERefUpdate.length - 1}명`
                  : !this.state.ERef
                  ? "받는 사람"
                  : `${this.state.ERef[0].SUNAME} 외 ${this.state.ERef.length -
                      1}명`}
              </button>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button type="submit">제출</button>
              </div>
            </form>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(NoticeEditPage);
